import { g } from '@pretto/bricks/components/layout'
import * as typo from '@pretto/bricks/core/typography'
import SentenceDateField from '@pretto/bricks/components/form/SentenceDateField'
import styled from 'styled-components'

export const InputDate = styled(SentenceDateField)``
export const Title = styled.div`
  ${typo.headline16};
`
export const Description = styled.p`
  ${typo.caption12};
  color: ${({ theme }) => theme.colors.neutral2};
  margin-top: ${g(1)};
`
